/* @flow */
import * as React from 'react';

import styles from './styles.module.scss';

import type { Production } from 'types';

import { get } from 'lodash';

type Props = Production;

class ProductionInfo extends React.PureComponent<Props, void> {
  render() {
    const { createDate, modifiedDate } = this.props;

    return (
      <div className={styles.container}>
        <dl>
          <dt>{'produzioneId:'}</dt>
          <dd>{get(this.props, 'id')}</dd>
          <dt>{'uuid:'}</dt>
          <dd>{get(this.props, 'uuid')}</dd>
          <dt>{'nomeProduzione:'}</dt>
          <dd>{get(this.props, 'name')}</dd>
          <dt>{'createDate:'}</dt>
          <dd>{createDate && new Date(createDate).toISOString()}</dd>
          <dt>{'modifiedDate:'}</dt>
          <dd>{modifiedDate && new Date(modifiedDate).toISOString()}</dd>
          <dt>{'edizione:'}</dt>
          <dd>{get(this.props, 'edition')}</dd>
          <dt>{'areaId:'}</dt>
          <dd>{get(this.props, 'area.id')}</dd>
          <dt>{'area:'}</dt>
          <dd>{get(this.props, 'area.name')}</dd>
          <dt>{'canaleId:'}</dt>
          <dd>{get(this.props, 'channel.id')}</dd>
          <dt>{'canale:'}</dt>
          <dd>{get(this.props, 'channel.name')}</dd>
          <dt>{'emittenteId:'}</dt>
          <dd>{get(this.props, 'broadcasting.id')}</dd>
          <dt>{'emittente:'}</dt>
          <dd>{get(this.props, 'broadcasting.name')}</dd>
          <dt>{'piattaformaId:'}</dt>
          <dd>{get(this.props, 'platform.id')}</dd>
          <dt>{'piattaforma:'}</dt>
          <dd>{get(this.props, 'platform.name')}</dd>
          <dt>{'produttoreId:'}</dt>
          <dd>{get(this.props, 'producer.id')}</dd>
          <dt>{'produttore:'}</dt>
          <dd>{get(this.props, 'producer.name')}</dd>
          <dt>{'tipologiaEmissioneId:'}</dt>
          <dd>{get(this.props, 'broadcastType.id')}</dd>
          <dt>{'tipologiaEmissione:'}</dt>
          <dd>{get(this.props, 'broadcastType.name')}</dd>
          <dt>{'tipologiaProduzioneId:'}</dt>
          <dd>{get(this.props, 'productionType.id')}</dd>
          <dt>{'tipologiaProduzione:'}</dt>
          <dd>{get(this.props, 'productionType.name')}</dd>
        </dl>
      </div>
    );
  }
}

export default ProductionInfo;
